<template>
  <div>
    <DarkModeSwitcher />
    <template v-if="loading">
      <LoadingIcon />
    </template>
    <div class="container sm:px-10">
      <div class="block xl:grid grid-cols-2 gap-4">
        <!-- BEGIN: Login Info -->
        <div class="hidden xl:flex flex-col min-h-screen">
          <a href="" class="-intro-x flex items-center pt-5">
            <img
              alt="Midone Tailwind HTML Admin Template"
              class="w-6"
              :src="require(`@/assets/images/logo.svg`)"
            />
            <span class="text-white text-2xl ml-3">
              MSN
            </span>
          </a>
          <div class="my-auto">
            <img
              alt="Midone Tailwind HTML Admin Template"
              class="-intro-x w-1/2 -mt-16"
              :src="require(`@/assets/images/illustration.svg`)"
            />
            <div
              class="-intro-x text-white font-medium text-4xl leading-tight mt-10"
            ></div>
            <div
              class="-intro-x mt-5 text-lg text-white dark:text-gray-500"
            ></div>
          </div>
        </div>
        <!-- END: Login Info -->
        <!-- BEGIN: Login Form -->
        <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
          <div
            class="my-auto mx-auto xl:ml-20 bg-white xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto"
          >
            <h2
              class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left"
            >
              로그인
            </h2>
            <div class="intro-x mt-8">
              <input
                v-model="loginForm.userId"
                type="text"
                autocomplete="off"
                class="intro-x login__input w-full input input--lg border border-gray-300 block"
                placeholder="이메일"
                @keyup.enter="handleLogin"
              />
              <input
                v-model="loginForm.userPwd"
                type="password"
                autocomplete="off"
                class="intro-x login__input w-full input input--lg border border-gray-300 block mt-4"
                placeholder="비번"
                @keyup.enter="handleLogin"
              />
            </div>
            <div
              class="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4"
            >
              <div class="flex items-center mr-auto">
                <input
                  v-model="isSave"
                  type="checkbox"
                  autocomplete="off"
                  class="input border mr-2"
                  @change="onSave"
                />
                <label class="cursor-pointer select-none" for="remember-me"
                  >저장</label
                >
              </div>
            </div>
            <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
              <button
                class="button button--lg w-full xl:w-32 text-white bg-theme-1 xl:mr-3 align-top"
                @click="handleLogin"
              >
                로그인
              </button>
              <button
                class="button button--lg w-full xl:w-32 text-gray-700 border border-gray-300 dark:border-dark-5 dark:text-gray-700 mt-3 xl:mt-0 align-top"
                @click="signUp"
              >
                등록
              </button>
            </div>
          </div>
        </div>
        <!-- END: Login Form -->
      </div>
    </div>
  </div>
</template>

<script>
import DarkModeSwitcher from "@/components/DarkModeSwitcher";
import axios from "axios";
import Toastify from "toastify-js";

export default {
  components: {
    DarkModeSwitcher
  },
  data: () => ({
    loading: false,
    loginForm: {
      userId: "",
      userPwd: ""
    },
    isSave: false
  }),
  mounted() {
    cash("body")
      .removeClass("app")
      .addClass("login");
    this.$store.commit("auth/SET_USER", null);
    this.$store.commit("auth/SET_ISLOGINED", false);
    if (window.localStorage.getItem("exchange_is_save") === "true") {
      this.isSave = true;
    } else {
      this.isSave = false;
    }
    this.loginForm.userId = window.localStorage.getItem("exchange_user_id");
  },
  methods: {
    onSave() {
      window.localStorage.setItem("exchange_is_save", this.isSave);
      if (this.isSave) {
        window.localStorage.setItem("exchange_user_id", this.loginForm.userId);
      } else {
        window.localStorage.setItem("exchange_user_id", "");
      }
    },
    signUp() {
      this.$router.replace("/register");
    },
    async handleLogin() {
      // console.log("this.loginForm.userId : ", this.loginForm.userId);
      if (this.isSave) {
        window.localStorage.setItem("exchange_user_id", this.loginForm.userId);
      } else {
        window.localStorage.setItem("exchange_user_id", "");
      }
      // console.log("login btn clicked.");
      this.startLoading();
      let data = {
        email: this.loginForm.userId,
        password: this.loginForm.userPwd
      };
      // console.log("loginData : ", data);
      let resultData = {};
      await axios.post(this.$api().login, data).then(res => {
        resultData = res.data;
      });
      this.finishLoading();
      if (this.$h.isEmpty(resultData)) {
        Toastify({
          text: "서버와의 접속에 문제가 있습니다.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: "#0e2c88",
          stopOnFocus: true
        }).showToast();
      } else if (resultData.error) {
        // console.log(resultData.error);
        Toastify({
          text: `${
            resultData.error.email
              ? resultData.error.email
              : resultData.error.password
          }`,
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: "#0e2c88",
          stopOnFocus: true
        }).showToast();
      } else {
        this.$store.commit("auth/SET_USER", resultData.userData);
        this.$store.commit("auth/SET_ISLOGINED", true);
        window.localStorage.setItem(
          "exchange_token",
          resultData.userData.token
        );
        Toastify({
          text: "로그인 성공",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: "#0e2c88",
          stopOnFocus: true
        }).showToast();
        if (resultData.userData.isAdmin == 0) {
          this.$router.replace("/main/transaction");
        } else {
          this.$router.replace("/main/agency-list");
        }
      }
    },
    startLoading() {
      this.loading = true;
    },
    finishLoading() {
      this.loading = false;
    }
  }
};
</script>
